// Modules
import axios, { AxiosInstance, AxiosRequestConfig } from "axios"

// Constants
import config from "~constants/config"

export const createAxiosInstance = (
  customOptions?: AxiosRequestConfig
): AxiosInstance => {
  const defaultOptions: AxiosRequestConfig = {
    headers: {
      common: {
        Accept: "application/json",
        Authorization: `Basic ${btoa(
          config.authClientId + `:` + config.authClientSecret
        )}`,
      },
    },
  }

  const combinedOptions = { ...defaultOptions, ...customOptions }
  return axios.create(combinedOptions)
}

export const createAxiosRequestConfig = (
  accessToken?: string
): AxiosRequestConfig => {
  const auth = accessToken ? `Bearer ${accessToken}` : ``
  return {
    withCredentials: !!accessToken,
    headers: {
      common: {
        Authorization: auth,
      },
    },
  }
}
